export enum WidgetType {
  ALERT = 'ALERT',
  ALARM_HISTORY = 'ALARM_HISTORY',
  BAR_CHART = 'BAR_CHART',
  BASE = 'BASE',
  DONUT_CHART = 'DONUT_CHART',
  DIVIDER = 'DIVIDER',
  FORMULA = 'FORMULA',
  GAUGE = 'GAUGE',
  IMAGE = 'IMAGE',
  LINE_CHART = 'LINECHART',
  LIQUID = 'LIQUID',
  MAP = 'MAP',
  PENDING_ALERTS = 'PENDING_ALERTS',
  PIECHART = 'PIECHART',
  SENSOR_LIST = 'SENSOR_LIST',
  TABLE = 'TABLE',
  TEXT = 'TEXT',
  TRAFFIC_LIGHT = 'TRAFFIC_LIGHT',
  VALUE = 'VALUE',
  INPUT = 'INPUT',
}
